<template>
  <Team_post_investment_operation_bar_m></Team_post_investment_operation_bar_m>
  <router-view></router-view>
</template>

<script>
import Team_post_investment_operation_bar_m from "@/components/CN_mobile/team/Team_post_investment_operation_bar_m";
export default {
  name: 'Team_post_investment_operation_m',
  components: {Team_post_investment_operation_bar_m, },
}

</script>

<style scoped>

</style>